import { render, staticRenderFns } from "./member-table-component.vue?vue&type=template&id=446ba8de&scoped=true&lang=pug"
import script from "./member-table-component.js?vue&type=script&lang=js&external"
export * from "./member-table-component.js?vue&type=script&lang=js&external"
import style0 from "./member-table-component.vue?vue&type=style&index=0&id=446ba8de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446ba8de",
  null
  
)

export default component.exports